/* 🤖 this file was generated by svg-to-ts */
export const sbIconsChevronLeft: {
  name: 'chevron-left';
  data: string;
} = {
  name: 'chevron-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="m8.58588 9.95803 6.71992-6.71994a1.898 1.898 0 0 0 .552-1.33829 1.898 1.898 0 0 0-.552-1.33829 1.899 1.899 0 0 0-.6177-.41552A1.899 1.899 0 0 0 13.958 0a1.898 1.898 0 0 0-.73.146 1.899 1.899 0 0 0-.6178.41551L4.56151 8.61024a1.89838 1.89838 0 0 0-.41552 2.07786c.09638.2313.2376.4412.41552.6177l8.04869 8.1437c.1774.1759.3878.3151.6191.4096.2312.0944.4789.1423.7287.1409.2499.0014.4975-.0465.7288-.1409.2313-.0945.4416-.2337.619-.4096.3536-.3557.552-.8368.552-1.3383a1.898 1.898 0 0 0-.552-1.3383z"/></svg>`
};
